// extracted by mini-css-extract-plugin
module.exports = {"container":"CaseModale_container__1o2iS","actions":"CaseModale_actions__2mav-"};